import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {UsuarioModule} from './usuario/usuario.module';
import {RolesModule} from "./roles/roles.module";
import {AuditoriaModule} from "./auditoria/auditoria.module";
import {EmisorModule} from "./emisor/emisor.module";
import {ConfiguracionModule} from './configuracion/configuracion.module';
import {EmisorTercerosModule} from "../transaccion/emisorTerceros/emisorTerceros.module";

@NgModule({
    imports: [
        CommonModule,
        UsuarioModule,
        EmisorTercerosModule,
        EmisorModule,
        RolesModule,
        AuditoriaModule,
        ConfiguracionModule
    ],
    declarations: []
})
export class SeguridadModule {
}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/seguridad/seguridad.module.ts